export default "__VITE_ASSET__W$BVs3GQ__"